var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useLayoutEffect, useRef, useState, } from 'react';
import classNames from 'classnames';
import { STATIC_BASE_URL } from '@anwb/style-utilities';
import { useElementVisibility } from '@anwb/use-element-visibility';
import { ImageError } from './components/ImageError';
import { Image } from './styles/image.styled';
/**
 * The Image component is used to render an image with the correct styling and optional fallback error image
 */
const ImageComponent = (_a) => {
    var { className, src, srcset, sizes, alt, class: reactClassName, inline, lazy, imageWidth, alignment, coverContainer, onErrorStateChange, dataTest = 'image', fallbackImage } = _a, props = __rest(_a, ["className", "src", "srcset", "sizes", "alt", "class", "inline", "lazy", "imageWidth", "alignment", "coverContainer", "onErrorStateChange", "dataTest", "fallbackImage"]);
    const imageRef = useRef(null);
    const isVisible = useElementVisibility({ element: imageRef, active: lazy });
    const [showPlaceholder, setShowPlaceholder] = useState(lazy);
    const [error, setError] = useState(false);
    const requiredWidth = imageWidth === 'half' ? 'half' : 'full';
    const imageClassNames = classNames('PONCHO-image', `PONCHO-image--${requiredWidth}-width`, className || reactClassName, {
        'PONCHO-image--inline': !!inline,
        'PONCHO-image--left': alignment === 'left',
        'PONCHO-image--right': alignment === 'right',
        'PONCHO-image--cover-container': !!coverContainer,
    });
    useLayoutEffect(() => {
        setError(false);
    }, [src]);
    useEffect(() => {
        if (lazy && isVisible)
            setShowPlaceholder(false);
    }, [lazy, isVisible]);
    useEffect(() => {
        if (onErrorStateChange)
            onErrorStateChange(error);
    }, [onErrorStateChange, error]);
    if (error && !fallbackImage) {
        return (React.createElement(ImageError, { className: imageClassNames, dataTest: `${dataTest}-error`, inline: inline, width: requiredWidth, alignment: alignment, coverContainer: coverContainer }));
    }
    if (error && fallbackImage) {
        return (React.createElement(Image, Object.assign({ className: imageClassNames, alt: "Geen afbeelding beschikbaar", src: fallbackImage || `${STATIC_BASE_URL}/poncho/image/images/error-placeholder.svg`, "data-test": `${dataTest}-error`, "$inline": inline, "$width": requiredWidth, "$alignment": alignment, "$coverContainer": coverContainer }, props)));
    }
    return (React.createElement(Image, Object.assign({ ref: imageRef, className: imageClassNames, alt: alt, "data-test": dataTest, "$inline": inline, "$width": requiredWidth, "$alignment": alignment, "$coverContainer": coverContainer, onError: () => setError(true), src: showPlaceholder ? `${STATIC_BASE_URL}/poncho/image/images/placeholder.svg` : src, srcSet: showPlaceholder ? undefined : srcset, sizes: showPlaceholder ? undefined : sizes }, props)));
};
ImageComponent.defaultProps = {
    lazy: false,
};
export default ImageComponent;
//# sourceMappingURL=Image.js.map